import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import MuiBox from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import MuiTypography from '@mui/material/Typography';

const Root = styled(MuiBox) `
  display: flex;
  align-items: center;
  &:hover #label {
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;
const Label = styled(MuiTypography) `
  margin: ${({ theme }) => theme.spacing(0, 0, 0, 2)};
  color: ${({ theme }) => theme.palette.N20.main};
`;
const BaseBreadcrumbOption = (_a) => {
    var { label, icon: Icon } = _a, rest = __rest(_a, ["label", "icon"]);
    return (jsxs(Root, Object.assign({}, rest, { children: [Icon && jsx(Icon, {}), jsx(Label, Object.assign({ id: "label", variant: "h5" }, { children: label }))] })));
};

export { BaseBreadcrumbOption as default };
//# sourceMappingURL=BaseBreadcrumbOption.js.map
